import styled from 'styled-components';
import { useEffect, useState } from 'react';
import * as Server from "../../assets/js/Server";

import {confirmAlert} from "react-confirm-alert";

export default function ConsultForm() {
  const [param, setParam] = useState({
    userName: '',
    userPhone: '',
    userEmail: '',
    userCity: '',
    companyName: '',
    pestProblem: '',
    type: '',
    address: '',
    inquiry: '',
  });

  const [isRequest, setIsRequest] = useState(false);

  const sendRequest = () => {
    if (!isRequest) {
      setIsRequest(true);
      Server.sendPostInHq(
        'home/inquiry',
        param, sendRequestCallback
      ).then();
    }
  }

  const sendRequestCallback = res => {
    confirmAlert({
      title: 'Complete.',
      buttons: [{
        label: 'Yes'
      }]
    });
    setIsRequest(false);
  }

  const getCustomerInfo = () => {
    Server.sendGet('customer/info', {}, getCustomerInfoCallback).then();
  }

  const getCustomerInfoCallback = res => {
    const result = res?.['resultObject'];

    setParam(() => {
      return {
        ...param,
        userName: result.userName,
        userEmail: result.mailAddress
      }
    })
  }

  useEffect(() => {
    getCustomerInfo();
  }, []);


  return (
    <ConsultFormBox>
      <div className="form-title">
        <strong>Ready to see the pest free space?</strong>
        <p>Keep your restaurant and cafe pest-free with our expert services.</p>
      </div>
      <div className="form-content">
        <div className="form-box">
          <div className="form-row">
            <label htmlFor="consult-name">Name</label>
            <input
              type="text"
              name="consult-name"
              id="consult-name"
              placeholder="Full Name"
              value={param?.userName}
              onChange={e => setParam(() => {
                return {
                  ...param,
                  userName: e.target.value
                }
              })}
            />
          </div>
          <div className="form-row">
            <label htmlFor="consult-phone">Mobile</label>
            <input
              type="text"
              name="consult-phone"
              id="consult-phone"
              placeholder="Phone Number"
              onChange={e => setParam(() => {
                return {
                  ...param,
                  userPhone: e.target.value
                }
              })}
            />
          </div>
          <div className="form-row">
            <label htmlFor="consult-mail">Email</label>
            <input
              type="text"
              name="consult-mail"
              id="consult-mail"
              placeholder="Email"
              value={param?.userEmail}
              onChange={e => setParam(() => {
                return {
                  ...param,
                  userEmail: e.target.value
                }
              })}
            />
          </div>
          <div className="form-row">
            <label htmlFor="consult-company">Name</label>
            <input
              type="text"
              name="consult-company"
              id="consult-company"
              placeholder="Company Name"
              onChange={e => setParam(() => {
                return {
                  ...param,
                  companyName: e.target.value
                }
              })}
            />
          </div>
          <div className="form-row">
            <label htmlFor="consult-city">Name</label>
            <input
              type="text"
              name="consult-city"
              id="consult-city"
              placeholder="City"
              onChange={e => setParam(() => {
                return {
                  ...param,
                  userCity: e.target.value
                }
              })}
            />
          </div>
        </div>
        <button
          onClick={() => sendRequest()}
        >Submit</button>
      </div>
    </ConsultFormBox>
  )
}

const ConsultFormBox = styled.div`
  position:relative;
  padding:100px 50px;
  background:#fff url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/apec_people.webp') bottom 0 right 0 no-repeat;
  background-size:200px;
  border-radius:30px;
  flex:1;
  
  .form-title {
    position:relative;
    strong {
      font-weight:600;
      font-size:2.5rem;
      color:#000;
    }
    
    p {
      display:block;
      margin-top:15px;
      font-weight:400;
      font-size:1.5rem;
      line-height:1.2;
      color:#000;
    }
  }
  
  .form-content {
    margin-top:60px;
    position:relative;
    text-align:center;
    
    .form-box {
      position:relative;
      
      .form-row {
        position:relative;
        text-align:left;
        
        label {
          display:none;
        }
        
        input {
          width:100%;
          padding:0 20px;
          height:50px;
          line-height:50px;
          font-weight:400;
          font-size:1.2rem;
          color:#a9a9a9;
          border:2px solid #737373;
          border-radius:10px;
        }
      }
      
      .form-row + .form-row {
        margin-top:20px;
      }
    }
    
    
    button {
      margin-top:45px;
      display:inline-block;
      padding:0 30px;
      height:50px;
      line-height:50px;
      font-weight:500;
      font-size:1.2rem;
      color:#fff;
      border-radius:10px;
      background:#0072B9;
    }
  }

  @media only screen and (max-width: 1024px) {
    padding:40px 20px;
    text-align:center;
    background:#ffffff;
    
    .form-title {
      strong {
        font-size:2rem;
      }
      
      p {
        font-size:1rem;
      }
      
    }

    .form-content {
      margin-top:30px;

      .form-box {
        position:relative;

        .form-row {
          input {
            width:100%;
          }
        }

        .form-row + .form-row {
          margin-top:10px;
        }
      }


      button {
        margin-top:25px;
        width:100%;
      }
    }
  }

  @media only screen and (max-width: 640px) {
    .form-title {
      strong {
        font-size:1.5rem;
      }
    }
  }
`
